import '@fontsource-variable/fraunces'
import '@fontsource-variable/plus-jakarta-sans'
import '@fontsource/amiri-quran'
import './styles/tokens.css'
import './styles/base.css'
import './styles/components.css'
import './styles/ayat.css'
import './styles/quran.css'
import './styles/onboarding.css'
import './styles/pegangan.css'
import './styles/mutiara.css'
import './styles/cerita.css'
import './styles/perjalanan.css'
import './styles/motion.css'

import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './App.tsx'
import { initMotion } from './lib/motion.ts'
import { captureInstallPrompt } from './lib/platform.ts'
import { applyFontScale } from './lib/prefs.ts'
import { makeQueryClient } from './lib/queries.ts'
import { startSmoothScroll } from './lib/scroll.ts'

applyFontScale()
captureInstallPrompt()
initMotion()
startSmoothScroll()
const queryClient = makeQueryClient()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
